var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 4.16663H5.83333C5.61232 4.16663 5.40036 4.25442 5.24408 4.4107C5.0878 4.56698 5 4.77895 5 4.99996V17.5C5 17.721 5.0878 17.9329 5.24408 18.0892C5.40036 18.2455 5.61232 18.3333 5.83333 18.3333H14.1667C14.3877 18.3333 14.5996 18.2455 14.7559 18.0892C14.9122 17.9329 15 17.721 15 17.5V4.99996C15 4.77895 14.9122 4.56698 14.7559 4.4107C14.5996 4.25442 14.3877 4.16663 14.1667 4.16663Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5H15",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.25V8.75",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.25V8.75",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 1.66663H6.6665V4.16663H13.3332V1.66663Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 12.9166H11.6668",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25V14.5833",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMedication);
export default __webpack_public_path__ + "static/media/ic-medication.e0e491743e0bab99f65258e7bec6e967.svg";
export { ForwardRef as ReactComponent };